/*
Sohel 03/20/2023 2699762545 Added Disposition Screen
Guru Prasad 03/20/2023 2699762545 Fixed input fields UI
Sohel 03/22/2023 2699762545 Integrated Save and Get API
Prakash 03/23/2023 2699762545 Fixed Autocomplete input fields UI.
Ravi 03/23/2023 2699762545 prepopulate data during editing
Sohel 03/27/2023 2699762545 Payload Changes
Dilip 03/27/2023 2699762545 added bredcrums to show code and description
Akhila 03/27/2023 2699762545 Added save button
Sohel 03/28/2023 2699762545 Added HandleBack
Guru Prasad 04/03/2023 2699762545 Fixed column spacing issues
Prakash 11-04-23 2699762545 remove white space issue in letter maintainance
Ravi 04/12/2023 2699762545 Added unsaved popup changes
Akhila 05/24/2024 2699762545 role access implemeneted
Prakash 19-06-23 2699762545 fixed alignments issus in tab view in letter maintainance
Ravi 06/21/2023 2699762545 fixed submit issue
*/
import React, {useEffect, useContext, useRef} from 'react';
import {Button, Checkbox, FormControl, FormHelperText} from '@material-ui/core';
import {Formik} from 'formik';
import GuiAutoComplete from '../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../components/FormComponents/GuiTextField';
// import ReusableInputStyles from "../../../components/InputStyles";
import * as Yup from 'yup';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import {DISPOSITION_CODE} from '../../../constants/Lookup';
import {useDispatch, useSelector} from 'react-redux';
import {
  fetchDispositionsData,
  getDropDownData,
  postDispositionsInfo,
  resetBasicInfo,
} from '../../../redux/reducers/LetterMaintainance/NewLetterMaintenance';
import PageLoader from '../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../components/CustomSnackBar';
import {ThemeContext} from '../../../themes/ThemeProvider';
import BreadCrums from '../../../util/BreadCrum';
import {submissionStart} from '../../../redux/reducers/CommonActions/commonActions';
const includeOptions = [
  {key: 'Y', value: 'Yes'},
  {key: 'N', value: 'No'},
];

function Dispositions({handleNext, handleBack, handleDirty, LetterMainAccess, editExisting}) {
  const getObjects = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item.value === option || item.key === option || item.categoryCode === option) {
          label = item;
        }
      });
    return label;
  };
  const validationSchema = Yup.object().shape({
    include: Yup.mixed().test('include', 'Include is Required', (val) => {
      if (!val?.key) {
        return false;
      } else {
        return true;
      }
    }),
    dispositions: Yup.mixed().test('dispositions', 'Status is Required', (val) => {
      if (!val?.length) {
        return false;
      } else {
        return true;
      }
    }),
  });

  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const {
    letterCode,
    isBasicInfoLoading,
    basicInfoSuccessMsg,
    basicInfoErrorMsg,
    basicInfoStatus,
    basicInfoData,
    dropDownData,
    dispositionData,
  } = useSelector(({newLetterMaintenance}) => newLetterMaintenance);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const getDispositionCodes = (user, dispositionData) => {
    return dispositionData?.filter((i) => user?.includes(i?.valueCode));
  };
  const getOptions = (typeCode) => {
    let label = [];
    label = dropDownData && dropDownData[typeCode] ? dropDownData[typeCode] : [];
    return label;
  };
  const initialVal = {
    include: dispositionData?.include ? getObjects(dispositionData?.include, includeOptions) : null,
    dispositions:
      dispositionData?.dispositionCodes?.length > 0 ?
        getDispositionCodes(dispositionData?.dispositionCodes, getOptions(DISPOSITION_CODE)) :
        [],
  };

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const dispatch = useDispatch();
  const saveRef = useRef();
  useEffect(() => {
    dispatch(getDropDownData());
  }, []);
  const handleSubmit = (values) => {
    dispatch(submissionStart());
    const dispositionCode =
      values?.dispositions?.length > 0 ? values?.dispositions?.map((el) => el?.valueCode) : [];
    const payload = {
      letterCode: letterCode,
      dispositionCode: dispositionCode,
      include: values?.include?.key ? values?.include?.key : '',
      isDraft: basicInfoData?.isDraft === 'N' ? 'N' : 'Y',
      lastStep: basicInfoData?.lastStep > 3 ? basicInfoData?.lastStep : 3,
    };
    dispatch(postDispositionsInfo(payload));
  };
  useEffect(() => {
    if (basicInfoSuccessMsg || basicInfoErrorMsg) {
      setTimeout(() => {
        dispatch(resetBasicInfo());
        if (basicInfoSuccessMsg && basicInfoStatus === 200 && !saveRef.current) {
          handleNext();
        } else if (basicInfoSuccessMsg && basicInfoStatus === 200 && saveRef.current) {
          dispatch(fetchDispositionsData(letterCode));
        }
      }, 2000);
    }
  }, [basicInfoErrorMsg, basicInfoSuccessMsg, basicInfoStatus]);
  useEffect(() => {
    if (letterCode) {
      dispatch(fetchDispositionsData(letterCode));
    }
  }, [letterCode]);
  return (
    <>
      <div className="mb-2">
        <BreadCrums
          name={'Letter Code'}
          code={basicInfoData?.letterCode}
          description={'Letter Description'}
          descriptionValue={basicInfoData?.letterDescription}
        />
      </div>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialVal}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {(props) => {
          const {values, errors, touched, handleChange, handleSubmit, setFieldValue, dirty} =
            props;
          handleDirty && handleDirty(dirty);
          return (
            <form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <div className="form-row standard-field-textfields new-standard-textfields ">
                <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3 form-group">
                  <GuiAutoComplete
                    classes={{
                      option: classes.option,
                    }}
                    name="include"
                    id="include"
                    size="small"
                    options={includeOptions}
                    required
                    value={values.include}
                    getOptionLabel={(option) => {
                      return option && option.value;
                    }}
                    onChange={(e, value) => {
                      setFieldValue('include', value);
                    }}
                    renderInput={(params) => (
                      <div className="select-field">
                        <GuiTextField
                          className={`${classes.labelName}`}
                          {...params}
                          variant="outlined"
                          margin="dense"
                          label="Include"
                          placeholder="Select Include"
                          required
                          error={touched.include && errors.include}
                        />
                      </div>
                    )}
                  />
                  <FormHelperText>
                    {touched.include && errors.include && errors.include}
                  </FormHelperText>
                </div>
                <div
                  className={`col-sm-6 col-md-8  col-lg-8 col-xl-6 form-group autocomplete-field ${
                    values?.dispositions?.length > 2 && `autocomplete-checkbox`
                  }`}
                >
                  <FormControl margin="dense" variant="outlined" fullWidth>
                    <GuiAutoComplete
                      name={'dispositions'}
                      id={'dispositions'}
                      size="small"
                      limitTags={1}
                      classes={{
                        option: classes.option,
                        listbox: classes.listBox,
                      }}
                      disableCloseOnSelect
                      getOptionSelected={(option, value) => option?.valueCode === value?.valueCode}
                      value={values?.dispositions?.length > 0 ? values?.dispositions : []}
                      multiple
                      onChange={(e, value) => {
                        handleChange(e);
                        setFieldValue('dispositions', value);
                      }}
                      options={getOptions(DISPOSITION_CODE) || []}
                      autoHighlight
                      renderOption={(option, {selected}) => {
                        return (
                          <React.Fragment>
                            <>
                              <Checkbox
                                icon={icon}
                                checkedIcon={
                                  <CheckBoxIcon fontSize="small" className="selectcheckBox" />
                                }
                                checked={selected}
                              />
                            </>
                            {option?.valueCode} - {option?.value}
                          </React.Fragment>
                        );
                      }}
                      getOptionLabel={(option) => {
                        return option?.valueCode + ' - ' + option?.value;
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            {...params}
                            className={`autocomplete-multiselect-label ${classes.labelName}`}
                            variant="outlined"
                            margin="dense"
                            required
                            error={touched?.dispositions && errors?.dispositions}
                            label={'Status'}
                            placeholder={`Select Status`}
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'off',
                            }}
                          />
                        </div>
                      )}
                    />
                  </FormControl>
                  <FormHelperText variant="outlined">
                    {touched?.dispositions && errors?.dispositions ? errors.dispositions : ''}
                  </FormHelperText>
                </div>
              </div>
              <div className="d-flex justify-content-center align-items-center new-standard-textfields">
                <Button
                  onClick={() => {
                    handleBack();
                  }}
                  variant="outlined"
                  className={`reset-btn mr-1 ${classes.buttonRoot}`}
                >
                  Back
                </Button>
                {/* {basicInfoData?.isDraft === "N" && ( */}
                <Button
                  variant="outlined"
                  // type="submit"
                  className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                  disabled={(editExisting && !LetterMainAccess?.edit) || enabledSubmission}
                  onClick={() => {
                    handleSubmit();
                    saveRef.current = true;
                    handleDirty(false, 'fixed');
                  }}
                >
                  Save
                </Button>
                {/* )} */}
                <Button
                  variant="outlined"
                  // type="submit"
                  disabled={(editExisting && !LetterMainAccess?.edit) || enabledSubmission}
                  className={`search-btn ml-1 ${classes.buttonRoot}`}
                  onClick={() => {
                    saveRef.current = false;
                    handleSubmit();
                  }}
                >
                  Save & Next
                </Button>
              </div>
            </form>
          );
        }}
      </Formik>
      {isBasicInfoLoading && <PageLoader />}
      {basicInfoErrorMsg && <ErrorSnackbar errorMsg={basicInfoErrorMsg} />}
      {basicInfoSuccessMsg && <SuccessSnackbar successMsg={basicInfoSuccessMsg} />}
    </>
  );
}

export default Dispositions;
